export default {
  userRole: {
    SuperUser: "superuser",
    Manager: "manager",
    CustomerAdmin: "customer-admin",
    Customer: "customer",
    System: "system",
  },
};
